export class AuthError extends Error { constructor(m) { super(m); this.name = 'AuthError'; } }
export class PayloadTooLargeError extends Error { constructor(m) { super(m); this.name = 'PayloadTooLargeError'; } }
export class RateLimitError extends Error { constructor(m) { super(m); this.name = 'RateLimitError'; } }
export class TransformError extends Error { constructor(m) { super(m); this.name = 'TransformError'; } }

const RETRY_DELAY_MS = 2000;

export class ApiClient {
  constructor({ baseUrl = '' } = {}) {
    this.baseUrl = baseUrl;
  }

  async submitPIN(pin) {
    const res = await fetch(`${this.baseUrl}/api/pin`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ pin })
    });
    if (res.status === 401) throw new AuthError('Invalid PIN');
    if (res.status === 429) throw new RateLimitError('Too many attempts, try again later');
    if (!res.ok) throw new TransformError(`PIN submission failed: ${res.status}`);
    return await res.json();
  }

  transform(body) {
    const promise = this._transformImpl(body);
    // Suppress Node's unhandled-rejection event in the brief window before
    // the caller attaches an await. The original rejection still surfaces
    // to any later .then/.catch/await on the returned promise.
    promise.catch(() => {});
    return promise;
  }

  async _transformImpl(body) {
    let retried = false;
    while (true) {
      const res = await fetch(`${this.baseUrl}/api/transform`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (res.status === 401) throw new AuthError('Auth session expired. Refresh and re-enter PIN.');
      if (res.status === 413) {
        await res.json().catch(() => ({}));
        throw new PayloadTooLargeError('Section too large');
      }
      if (res.status === 429) {
        if (retried) throw new RateLimitError('Rate limit hit; please wait a minute');
        retried = true;
        await new Promise(r => setTimeout(r, RETRY_DELAY_MS));
        continue;
      }
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new TransformError(`Claude request failed (${res.status}): ${text.slice(0, 200)}`);
      }
      return await res.json();
    }
  }
}
